import moment from 'moment';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import SingleDatePicker from '@features/filter/Common/SingleDatePicker';
import FilterName from '@features/filter/v2/FilterName';

import { clearSelectedFilterName, storeItemInGlobalFilter } from '@store/actions/FilterAction';

import { changeDateFormat } from '@utils/Util';

const NotUsedSince = () => {
	const [selectedDate, setSelectedDate] = useState('');
	const dispatch = useDispatch();
	const notUsedRef = useRef(null);
	const { selectedCheckboxField } = useSelector((store) => store.slectedCheckBoxFieldStore);

	const onOutSideClick = () => {
		if (selectedCheckboxField === 'NOT_USED_SINCE') dispatch(clearSelectedFilterName());
	};

	useClickOutside(notUsedRef, onOutSideClick);

	const onApplyPriceRange = () => {
		let endDateDate = moment(new Date()).format('YYYY-MM-DD');
		let startDate = changeDateFormat(selectedDate, 'YYYY-MM-DD', 'DD MMM, YYYY');
		let formattedEndDate = changeDateFormat(endDateDate, 'YYYY-MM-DD', 'DD MMM, YYYY');
		let dateRange = {
			name: 'dateRange',
			type: 'dateRange',
			key: selectedDate + ',' + endDateDate,
			value: startDate + ' - ' + formattedEndDate,
			identifier: 'dateRange'
		};
		dispatch(storeItemInGlobalFilter(dateRange));
		onClearInput();
	};

	const onClearInput = () => {
		setSelectedDate('');
	};

	const onChangeHandler = (e) => {
		const { value } = e.target;
		setSelectedDate(value);
	};

	return (
		<div ref={notUsedRef}>
			<FilterName type="NOT_USED_SINCE" />
			<SingleDatePicker
				inputValue={selectedDate}
				onChangeHandler={onChangeHandler}
				onApplyHandler={onApplyPriceRange}
				placeHolderOne="Select Date"
				type="NOT_USED_SINCE"
				inputType="date"
				onClearInputFields={onClearInput}
			/>
		</div>
	);
};

export default NotUsedSince;
